import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function SectionTitle({ children, aside, id }: { children: ReactNode; aside?: ReactNode; id?: string }) {
  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
      <h2 id={id} className="font-display text-base font-semibold">
        {children}
      </h2>
      {aside}
    </div>
  );
}

/** Lista de pares rótulo/valor; valor vazio aparece como traço. */
export function Facts({ items, className }: { items: { label: string; value: ReactNode }[]; className?: string }) {
  return (
    <dl className={cn('grid gap-x-8 gap-y-4 sm:grid-cols-2', className)}>
      {items.map((i) => (
        <div key={i.label} className="min-w-0">
          <dt className="text-xs text-muted-foreground">{i.label}</dt>
          <dd className="mt-0.5 text-sm break-words">{i.value || <span className="text-muted-foreground">Não informado</span>}</dd>
        </div>
      ))}
    </dl>
  );
}

export function LoadingBlock({ rows = 3 }: { rows?: number }) {
  return (
    <div role="status" aria-label="Carregando" className="flex flex-col gap-3">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} aria-hidden className="skeleton h-12 w-full" />
      ))}
    </div>
  );
}
